export const API_BASE_URL = import.meta.env.VITE_API_URL || "https://api.earthnote.io/api";

export const ENDPOINTS = {
  ADDIN_CONFIG: "/addin/config",
} as const;

// Preview HTML markers
export const PREVIEW_MARKERS = {
  START: "<!-- EARTH_NOTE_PREVIEW_START -->",
  END: "<!-- EARTH_NOTE_PREVIEW_END -->",
  DATA_ATTRIBUTE: "data-earthnote-preview",
  GIF_ID_ATTRIBUTE: "data-earthnote-gif-id",
} as const;

// Signup URL for non-customers
export const SIGNUP_URL = "https://earthnote.io/signup";

// Settings URL for disabled users
export const SETTINGS_URL = "https://app.earthnote.io/settings";
